import { Eye, Heart, MessageSquareQuote, Repeat2, Share } from "lucide-react"

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

interface Metric {
  icon: React.ComponentType<{ className?: string }>
  value: number
  label: string
}

interface Props {
  likes: number
  views: number
  reposts: number
  shares: number
  quotes: number
  size?: "sm" | "md"
}

const METRICS: {
  key: keyof Omit<Props, "size">
  icon: Metric["icon"]
  label: string
}[] = [
  { key: "likes", icon: Heart, label: "Likes" },
  { key: "views", icon: Eye, label: "Views" },
  { key: "reposts", icon: Repeat2, label: "Reposts" },
  { key: "shares", icon: Share, label: "Shares" },
  { key: "quotes", icon: MessageSquareQuote, label: "Quotes" },
]

export default function EngagementMetrics({
  likes,
  views,
  reposts,
  shares,
  quotes,
  size = "md",
}: Props) {
  const iconClass = size === "sm" ? "size-3" : "size-3.5"
  const values = { likes, views, reposts, shares, quotes }

  const visible = METRICS.filter((m) => values[m.key] > 0)
  if (visible.length === 0) return null

  return (
    <TooltipProvider>
      {visible.map((m) => (
        <Tooltip key={m.key}>
          <TooltipTrigger asChild>
            <span className="text-muted-foreground flex items-center gap-1">
              <m.icon className={iconClass} />
              {values[m.key]}
            </span>
          </TooltipTrigger>
          <TooltipContent>{m.label}</TooltipContent>
        </Tooltip>
      ))}
    </TooltipProvider>
  )
}
